(function lawBookControllerDefinition() {
    'use strict';

    angular.module('LawBook')
        .controller('LawBookSignController', [
            '$scope', 'config', '$state', '$translate', '$stateParams', '$filter', 'errorsExtend', 'fileService', 'storageService', 'documentService', 'authExtend', 'alerts', 'organizationalUnitService', 'profileCertificateService', '$q', '$parse',
            function lawBookSignController($scope, config, $state, $translate, $stateParams, $filter, errors, fileService, storageService, documentService, authExtend, alerts, organizationalUnitService, profileCertificateService, $q, $parse) {
                function detectIE() {
                    var ua = window.navigator.userAgent;
                    $scope.ouName = authExtend.getOrganizationName();

                    var msie = ua.indexOf('MSIE ');
                    if (msie > 0) {
                        // IE 10 or older => return version number
                        return parseInt(ua.substring(msie + 5, ua.indexOf('.', msie)), 10);
                    }

                    var trident = ua.indexOf('Trident/');
                    if (trident > 0) {
                        // IE 11 => return version number
                        var rv = ua.indexOf('rv:');
                        return parseInt(ua.substring(rv + 3, ua.indexOf('.', rv)), 10);
                    }

                    return false;
                }

                $scope.file = {
                    password: undefined
                };

                $scope.legend = { type: 'warning', message: 'NoCertificateAvailable' };

                $scope.isDocumentLoaded = false;
                $scope.isInProgress = false;
                $scope.isLakaut = true;
                $scope.CountCertificates = null;

                $scope.IsIe = detectIE();

                $scope.tmpProcess = {
                    name: '',
                    metadatas: []
                };

                $scope.openAccordion = function () {
                    $scope.accordionOpened = !$scope.accordionOpened;
                    $scope.file.accordionIsOpen = $scope.accordionOpened;
                };

                $scope.cancel = function () {
                    documentService.deleteVersion($scope.document);
                    $state.goBack('lawbook-find');
                };

                $scope.load = function () {
                    $scope.checkOut();
                };

                $scope.checkOut = function () {
                    return documentService.checkoutWithExpiration($stateParams.id).then(function (result) {
                        $scope.document = result;
                        $scope.hasMetadata = result.documentTypes[0].metadatas.length > 0;

                        $scope.fileIds = [];
                        $scope.files = [];

                        // Filter the fileIds list to send only the noit signed
                        $scope.document.files.forEach(function (f) {
                            if (f.maxSigners > 0 && !f.isSigned) {
                                $scope.files.push(f);
                                $scope.fileIds.push(f.id);
                            }
                        });

                        $scope.getCertificates(result.organizationalUnitId);

                    }, function (error) {
                        errors.showError(error);
                        $state.goBack('lawbook-find');
                    });
                };

                $scope.getCertificates = function (ouId) {
                    var certificateFilters = {
                        organizationalUnitId: ouId,
                        enabled: true,
                        active: true,
                        type: 1, // Empleador
                        signType: 0 // Firma masiva
                    };

                    profileCertificateService.get(certificateFilters).then(function (result) {
                        if (result.length > 0) {
                            $scope.addCertificateMetadata(result);
                        }
                        $scope.CountCertificates = result.length;
                    }, function (error) {
                        errors.showError(error);
                        $state.goBack('lawbook-find');
                    }
                    );
                };

                $scope.addCertificateMetadata = function (certificates) {
                    $scope.tmpProcess.metadatas = [];

                    var metadataCertificates = {
                        idObject: certificates.id + '_wcertificate',
                        systemName: '_wcertificate',
                        metadataType: 'radio',
                        metadataLabel: 'Certificado',
                        metadataIsVisible: certificates.length > 1,
                        metadataEnabled: certificates.length > 1,
                        metadataIsRequired: true,
                        metadataValue: undefined,
                        metadataOptions: []
                    };

                    angular.forEach(certificates, function (certificate) {
                        var description = certificate.provider;
                        if (certificate.expirationDate) {
                            description = certificate.provider + ' (' + $filter('date')(certificate.expirationDate, 'dd/MM/yyyy') + ')';
                        }

                        metadataCertificates.metadataOptions.push({
                            id: certificate.id,
                            value: certificate.id,
                            description: description,
                            requirePassword: certificate.requirePassword,
                            supportDisagreement: certificate.supportDisagreement || certificate.provider === 'Encode',
                            action: certificate.singleSignatureAction
                        });
                    });

                    if (metadataCertificates.metadataOptions.length === 1) {
                        metadataCertificates.metadataValue = metadataCertificates.metadataOptions[0].value;
                        $scope.controlChanged(metadataCertificates);
                    }

                    $scope.tmpProcess.metadatas.push(metadataCertificates);
                };

                $scope.controlChanged = function (metadata) {
                    if (metadata.systemName === '_wcertificate') {
                        var selectedOption = $filter('filter')(metadata.metadataOptions, { value: metadata.metadataValue }, true);
                        if (selectedOption.length === 1) {
                            $scope.selectedCertificate = selectedOption[0];
                            $scope.disagreementIsEnabled = $scope.selectedCertificate.supportDisagreement;
                            $scope.isLakaut = $scope.selectedCertificate.action === 'signLakaut';
                        }
                    }
                }

                $scope.execute = function () {
                    if (!$scope.selectedCertificate.action) {
                        errors.showWarning('CertificateProviderNotConfigured');
                        return false;
                    }

                    var method = $parse($scope.selectedCertificate.action);

                    if (!method($scope)) {
                        errors.showWarning('CertificateProviderNotConfigured');
                        return false;
                    }

                    return method($scope)();
                };

                $scope.signEncode = function () {
                    if (!$scope.fileSign.$valid) {
                        $scope.fileSign.$setSubmitted();
                        errors.showError('VerifyFormData');
                        return false;
                    }

                    //Check if we have files to sign
                    if ($scope.fileIds.length < 1) {
                        $translate(['Warning', 'lawbookSignNoFiles', 'ErrorOk'])
                            .then(function (translated) {
                                alerts.alert(translated.Warning, translated.lawbookSignNoFiles, translated.ErrorOk).then(function (result) {
                                    $scope.cancel();
                                });
                            });
                    }
                    else {
                        // Change status
                        var statusMetadata = $scope.document.documentTypes[0].metadatas.filter(function (value) {
                            return value.systemName == "_estadoLLS";
                        }
                        );
                        statusMetadata[0].metadataValue = "03";

                        return documentService.checkoutWithExpiration($stateParams.id).then(function () {
                            return $scope.sendDocumentToSign().then(function () {});
                        }, function (error) {
                            errors.showError(error);
                        });
                    }
                };

                $scope.sendDocumentToSign = function () {
                    return documentService.signDocument($scope.document, $scope.fileIds, $scope.selectedCertificate.id, $scope.file.password, '#OuConfigSectionLawbook').then(function (result) {
                        $state.goBack('lawbook-detail', { id: document.id });
                    }, function (error) {
                        errors.showError(error);
                    });
                };

                $scope.signLakaut = function () {
                    //Check if we have files to sign
                    if ($scope.fileIds.length < 1) {
                        $translate(['Warning', 'lawbookSignNoFiles', 'ErrorOk'])
                            .then(function (translated) {
                                alerts.alert(translated.Warning, translated.lawbookSignNoFiles, translated.ErrorOk).then(function (result) {
                                    $scope.cancel();
                                    return;
                                });
                            });
                        return;
                    }

                    $scope.isInProgress = true;

                    documentService.shareBulkDocuments([$scope.document.id], true).then(function (responseShared) {
                        profileCertificateService.certicateLakautMultipleSign(responseShared, null, $scope.document.organizationalUnitId).then(function () {
                            var statusMetadata = $scope.document.documentTypes[0].metadatas.filter(function (value) {
                                return value.systemName == "_estadoLLS";
                            }
                            );
                            statusMetadata[0].metadataValue = "03";

                            return documentService.signDocumentsExternal([$scope.document], $scope.selectedCertificate.id).then(function (result) {
                                $state.goBack('lawbook-find');
                            }, function (error) {
                                $scope.isInProgress = false;
                                errors.showError(error);
                            });

                        }, function (error) {
                            $scope.isInProgress = false;
                            if (error.status === -1 && !error.data) {
                                errors.showError("SIGNLAKAUTERROR");
                            } else {
                                errors.showError(error);
                            }
                        });
                    }, function (error) {
                        $scope.isInProgress = false;
                        errors.showError(error);
                    });
                }

                $scope.signFileLakaut = function (file) {
                    var defered = $q.defer();
                    var promise = defered.promise;

                    fileService.share(file).then(function (response) {
                        profileCertificateService.certicateLakautSign(response).then(function (responseSign) {
                            defered.resolve();
                        }, function (error) {
                            defered.reject(error);
                        });

                    }, function (error) {
                        defered.reject(error);
                    });

                    return promise;
                }

                $scope.load();
            }
        ]);
})();
